/*
 * Ruby Lookbook — Teklif listesi
 * -----------------------------------------------------------------
 * Shopify sepetinden (Cart / Checkout / Draft Order) tamamen bagimsizdir.
 * Hicbir kod yolu /cart API'sine istek gondermez.
 * Kalici depolama: localStorage["ruby_quote_v1"]
 * Kayit sekli: [{ handle, title, image, url }]
 * -----------------------------------------------------------------
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ruby_quote_v1';
  var UPDATE_EVENT = 'quote:updated';

  /* ---------------------------------------------------------------
   * Store — localStorage erisilemezse (private mode, kapali cerez)
   * bellek icine duser; sayfa icinde calismaya devam eder.
   * ------------------------------------------------------------- */
  var memoryStore = null;

  function storageAvailable() {
    try {
      var probe = '__ruby_quote_probe__';
      window.localStorage.setItem(probe, '1');
      window.localStorage.removeItem(probe);
      return true;
    } catch (e) {
      return false;
    }
  }

  var hasStorage = storageAvailable();

  function normalize(item) {
    if (!item || typeof item !== 'object') return null;
    var handle = typeof item.handle === 'string' ? item.handle.trim() : '';
    if (!handle) return null;
    return {
      handle: handle,
      title: typeof item.title === 'string' ? item.title : handle,
      image: typeof item.image === 'string' ? item.image : '',
      url: typeof item.url === 'string' ? item.url : ''
    };
  }

  var Store = {
    read: function () {
      if (!hasStorage) return memoryStore ? memoryStore.slice() : [];
      var raw;
      try {
        raw = window.localStorage.getItem(STORAGE_KEY);
      } catch (e) {
        return [];
      }
      if (!raw) return [];
      var parsed;
      try {
        parsed = JSON.parse(raw);
      } catch (e) {
        return [];
      }
      if (!Array.isArray(parsed)) return [];
      var out = [];
      for (var i = 0; i < parsed.length; i++) {
        var item = normalize(parsed[i]);
        if (item && Store.indexOfIn(out, item.handle) === -1) out.push(item);
      }
      return out;
    },

    indexOfIn: function (list, handle) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].handle === handle) return i;
      }
      return -1;
    },

    write: function (list) {
      memoryStore = list.slice();
      if (hasStorage) {
        try {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
        } catch (e) {
          /* kota dolu — bellek kopyasi ile devam */
        }
      }
      document.dispatchEvent(
        new CustomEvent(UPDATE_EVENT, { detail: { list: list.slice() } })
      );
    },

    has: function (handle) {
      return Store.indexOfIn(Store.read(), handle) !== -1;
    },

    add: function (item) {
      var clean = normalize(item);
      if (!clean) return Store.read();
      var list = Store.read();
      if (Store.indexOfIn(list, clean.handle) === -1) list.push(clean);
      Store.write(list);
      return list;
    },

    remove: function (handle) {
      var list = Store.read();
      var idx = Store.indexOfIn(list, handle);
      if (idx !== -1) {
        list.splice(idx, 1);
        Store.write(list);
      }
      return list;
    },

    toggle: function (item) {
      var clean = normalize(item);
      if (!clean) return false;
      if (Store.has(clean.handle)) {
        Store.remove(clean.handle);
        return false;
      }
      Store.add(clean);
      return true;
    },

    count: function () {
      return Store.read().length;
    },

    /* URL'den gelen handle listesi yedek aktarim yoludur.
     * Ana kaynak her zaman localStorage'dir; yalnizca liste bossa devreye girer. */
    hydrateFromHandles: function (handles, lookup) {
      if (!handles || !handles.length) return Store.read();
      if (Store.count() > 0) return Store.read();
      var list = [];
      for (var i = 0; i < handles.length; i++) {
        var handle = String(handles[i]).trim();
        if (!handle) continue;
        var known = lookup && lookup[handle] ? lookup[handle] : null;
        var item = normalize({
          handle: handle,
          title: known ? known.title : handle,
          image: known ? known.image : '',
          url: known ? known.url : ''
        });
        if (item && Store.indexOfIn(list, item.handle) === -1) list.push(item);
      }
      if (list.length) Store.write(list);
      return Store.read();
    }
  };

  /* ---------------------------------------------------------------
   * Yardimcilar
   * ------------------------------------------------------------- */
  function onUpdate(handler) {
    document.addEventListener(UPDATE_EVENT, handler);
  }

  /* Liquid, ceviriye __COUNT__ yer tutucusunu gecirir (bir output blogunun
   * icine tekrar output yazilamadigi icin). Eski bicimi de destekleriz. */
  function formatTemplate(template, count) {
    if (!template) return String(count);
    return template
      .replace(/__COUNT__/g, String(count))
      .replace(/\{\{\s*count\s*\}\}/g, String(count));
  }

  /* Teklif formu bagiantisini kurar.
   * Temel adres Liquid'den gelir (ornegin /pages/teklif-formu?view=teklif-formu);
   * buradaki is yalnizca konseptler parametresini eklemek/guncellemek.
   * Mevcut parametreler (view gibi) korunur, preview_theme_id sabitlenmez. */
  function buildQuoteFormHref(baseHref, list) {
    if (!baseHref) return baseHref;

    var handles = [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].handle) handles.push(list[i].handle);
    }

    try {
      var url = new URL(baseHref, window.location.origin);
      if (handles.length) {
        url.searchParams.set('konseptler', handles.join(','));
      } else {
        url.searchParams.delete('konseptler');
      }
      if (url.origin !== window.location.origin) return url.href;
      return url.pathname + url.search + url.hash;
    } catch (e) {
      if (!handles.length) return baseHref;
      var hashIndex = baseHref.indexOf('#');
      var hash = hashIndex === -1 ? '' : baseHref.slice(hashIndex);
      var clean = hashIndex === -1 ? baseHref : baseHref.slice(0, hashIndex);
      var separator = clean.indexOf('?') === -1 ? '?' : '&';
      var encoded = [];
      for (var j = 0; j < handles.length; j++) {
        encoded.push(encodeURIComponent(handles[j]));
      }
      return clean + separator + 'konseptler=' + encoded.join(',') + hash;
    }
  }

  /* Konsept detay sayfasinin mutlak adresi.
   * localStorage'da goreli yol saklanir (ornegin /lookbook/<handle>);
   * e-postada tiklanabilir olmasi icin window.location.origin ile
   * mutlak hale getirilir. Yol yoksa handle'dan uretilir. */
  function absoluteConceptUrl(item) {
    if (!item) return '';
    var path = item.url || '';
    if (!path && item.handle) path = '/lookbook/' + item.handle;
    if (!path) return '';

    try {
      return new URL(path, window.location.origin).href;
    } catch (e) {
      if (/^https?:\/\//i.test(path)) return path;
      var origin = window.location.origin || '';
      return origin + (path.charAt(0) === '/' ? path : '/' + path);
    }
  }

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusableIn(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll(FOCUSABLE),
      function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      }
    );
  }

  /* ---------------------------------------------------------------
   * <quote-toggle> — "Teklife Ekle" / "Eklendi" butonu
   * Kart ve konsept detay sayfasinda ayni bilesen kullanilir.
   * ------------------------------------------------------------- */
  if (!window.customElements.get('quote-toggle')) {
    window.customElements.define(
      'quote-toggle',
      class QuoteToggle extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          if (!this.button) return;
          this.labelEl = this.querySelector('[data-quote-toggle-label]');
          this.onClick = this.onClick.bind(this);
          this.sync = this.sync.bind(this);
          this.button.addEventListener('click', this.onClick);
          onUpdate(this.sync);
          this.sync();
        }

        disconnectedCallback() {
          if (this.button) this.button.removeEventListener('click', this.onClick);
          document.removeEventListener(UPDATE_EVENT, this.sync);
        }

        get payload() {
          return {
            handle: this.dataset.handle || '',
            title: this.dataset.title || '',
            image: this.dataset.image || '',
            url: this.dataset.url || ''
          };
        }

        onClick(event) {
          /* Kart tamamen tiklanabilir oldugu icin link tetiklenmemeli. */
          event.preventDefault();
          event.stopPropagation();
          Store.toggle(this.payload);
        }

        sync() {
          var added = Store.has(this.dataset.handle || '');
          var labelAdd = this.dataset.labelAdd || 'Teklife Ekle';
          var labelAdded = this.dataset.labelAdded || 'Eklendi';
          this.classList.toggle('is-added', added);
          this.button.setAttribute('aria-pressed', added ? 'true' : 'false');
          this.button.classList.toggle('quote-toggle__button--added', added);
          if (this.labelEl) this.labelEl.textContent = added ? labelAdded : labelAdd;
          var aria = added ? this.dataset.ariaRemove : this.dataset.ariaAdd;
          if (aria) this.button.setAttribute('aria-label', aria);
        }
      }
    );
  }

  /* ---------------------------------------------------------------
   * <quote-count> — sayac rozeti
   * ------------------------------------------------------------- */
  if (!window.customElements.get('quote-count')) {
    window.customElements.define(
      'quote-count',
      class QuoteCount extends HTMLElement {
        connectedCallback() {
          this.sync = this.sync.bind(this);
          onUpdate(this.sync);
          this.sync();
        }

        disconnectedCallback() {
          document.removeEventListener(UPDATE_EVENT, this.sync);
        }

        sync() {
          var count = Store.count();
          if (this.textContent !== String(count)) {
            this.textContent = String(count);
            if (count > 0) {
              this.classList.remove('quote-count--bump');
              /* reflow — animasyonu yeniden tetikler */
              void this.offsetWidth;
              this.classList.add('quote-count--bump');
            }
          }
        }
      }
    );
  }

  /* ---------------------------------------------------------------
   * <quote-bar> — sag ust pill + sticky alt bar ortak kabugu
   * Secim yokken alt bar gizlenir.
   * ------------------------------------------------------------- */
  if (!window.customElements.get('quote-bar')) {
    window.customElements.define(
      'quote-bar',
      class QuoteBar extends HTMLElement {
        connectedCallback() {
          this.sticky = this.querySelector('[data-quote-sticky]');
          this.stickyLabel = this.querySelector('[data-quote-sticky-label]');
          this.sync = this.sync.bind(this);
          this.openDrawer = this.openDrawer.bind(this);
          Array.prototype.forEach.call(
            this.querySelectorAll('[data-quote-open]'),
            function (el) {
              el.addEventListener('click', this.openDrawer);
            }.bind(this)
          );
          onUpdate(this.sync);
          this.sync();
        }

        disconnectedCallback() {
          document.removeEventListener(UPDATE_EVENT, this.sync);
        }

        openDrawer(event) {
          event.preventDefault();
          var drawer = document.querySelector('quote-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open(event.currentTarget);
          }
        }

        sync() {
          var count = Store.count();
          if (this.sticky) {
            this.sticky.hidden = count === 0;
            this.classList.toggle('quote-bar--has-selection', count > 0);
          }
          if (this.stickyLabel) {
            this.stickyLabel.textContent = formatTemplate(
              this.stickyLabel.dataset.template || '{{ count }}',
              count
            );
          }
        }
      }
    );
  }

  /* ---------------------------------------------------------------
   * <quote-drawer> — sagdan acilan teklif listesi
   * Minimalista cart drawer deseni referans alinmistir; cart drawer
   * dosyalarina dokunulmaz, ayri bir bilesendir.
   * ------------------------------------------------------------- */
  if (!window.customElements.get('quote-drawer')) {
    window.customElements.define(
      'quote-drawer',
      class QuoteDrawer extends HTMLElement {
        connectedCallback() {
          this.panel = this.querySelector('[data-quote-panel]');
          this.overlay = this.querySelector('[data-quote-overlay]');
          this.listEl = this.querySelector('[data-quote-list]');
          this.emptyEl = this.querySelector('[data-quote-empty]');
          this.footerEl = this.querySelector('[data-quote-footer]');
          this.ctaEl = this.querySelector('[data-quote-cta]');
          this.headingCountEl = this.querySelector('[data-quote-heading-count]');

          this.sync = this.sync.bind(this);
          this.close = this.close.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.onListClick = this.onListClick.bind(this);

          if (this.overlay) this.overlay.addEventListener('click', this.close);
          Array.prototype.forEach.call(
            this.querySelectorAll('[data-quote-close]'),
            function (el) {
              el.addEventListener('click', this.close);
            }.bind(this)
          );
          if (this.listEl) this.listEl.addEventListener('click', this.onListClick);
          this.addEventListener('keydown', this.onKeydown);

          onUpdate(this.sync);
          this.sync();
        }

        disconnectedCallback() {
          document.removeEventListener(UPDATE_EVENT, this.sync);
        }

        open(trigger) {
          this.opener = trigger || null;
          this.setAttribute('open', '');
          document.body.classList.add('overflow-hidden');
          var focusables = focusableIn(this.panel || this);
          if (focusables.length) {
            window.setTimeout(function () {
              focusables[0].focus();
            }, 60);
          }
        }

        close() {
          if (!this.hasAttribute('open')) return;
          this.removeAttribute('open');
          document.body.classList.remove('overflow-hidden');
          if (this.opener && typeof this.opener.focus === 'function') {
            this.opener.focus();
          }
        }

        onKeydown(event) {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'Escape') {
            event.stopPropagation();
            this.close();
            return;
          }
          if (event.key !== 'Tab') return;
          var focusables = focusableIn(this.panel || this);
          if (!focusables.length) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        onListClick(event) {
          var button = event.target.closest('[data-quote-remove]');
          if (!button) return;
          event.preventDefault();
          Store.remove(button.getAttribute('data-quote-remove'));
        }

        buildRow(item) {
          var row = document.createElement('li');
          row.className = 'quote-drawer__item';

          var media = document.createElement('div');
          media.className = 'quote-drawer__media';
          if (item.image) {
            var img = document.createElement('img');
            img.src = item.image;
            img.alt = '';
            img.loading = 'lazy';
            img.decoding = 'async';
            img.width = 60;
            img.height = 60;
            media.appendChild(img);
          }
          row.appendChild(media);

          var body = document.createElement('div');
          body.className = 'quote-drawer__item-body';
          var title = document.createElement(item.url ? 'a' : 'span');
          title.className = 'quote-drawer__item-title';
          title.textContent = item.title;
          if (item.url) title.setAttribute('href', item.url);
          body.appendChild(title);
          row.appendChild(body);

          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'quote-drawer__remove';
          remove.setAttribute('data-quote-remove', item.handle);
          var removeLabel = (this.dataset.labelRemove || 'Cikar') + ': ' + item.title;
          remove.setAttribute('aria-label', removeLabel);
          remove.innerHTML =
            '<svg aria-hidden="true" focusable="false" viewBox="0 0 14 14" width="12" height="12">' +
            '<path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>';
          row.appendChild(remove);

          return row;
        }

        sync() {
          var list = Store.read();
          var count = list.length;

          if (this.headingCountEl) this.headingCountEl.textContent = String(count);

          if (this.listEl) {
            this.listEl.textContent = '';
            for (var i = 0; i < list.length; i++) {
              this.listEl.appendChild(this.buildRow(list[i]));
            }
            this.listEl.hidden = count === 0;
          }
          if (this.emptyEl) this.emptyEl.hidden = count > 0;
          if (this.footerEl) this.footerEl.hidden = count === 0;

          /* CTA hedefine secili handle'lari yedek aktarim olarak ekle.
           * Ana kaynak localStorage; URL parametresi yalnizca yedektir. */
          if (this.ctaEl) {
            if (!this.ctaEl.dataset.baseHref) {
              this.ctaEl.dataset.baseHref = this.ctaEl.getAttribute('href') || '';
            }
            this.ctaEl.setAttribute(
              'href',
              buildQuoteFormHref(this.ctaEl.dataset.baseHref, list)
            );
          }
        }
      }
    );
  }

  /* ---------------------------------------------------------------
   * Gonderim sonrasi basari durumu
   *
   * Basari iki yoldan gelebilir:
   *   1) form.posted_successfully? — Liquid data-server-success="true" basar
   *   2) URL'de submitted=1 — Shopify return_to ile yonlendirdiginde
   *
   * Liquid query string'i okuyamadigi icin ikinci durumu burada cozeriz.
   * Basari yoksa (normal ziyaret veya validasyon hatasi) tesekkur bolumu
   * gizli kalir, form gorunur kalir ve liste KESINLIKLE temizlenmez.
   * ------------------------------------------------------------- */
  function hasSubmittedFlag() {
    try {
      return new URLSearchParams(window.location.search).get('submitted') === '1';
    } catch (e) {
      return /[?&]submitted=1(&|$)/.test(window.location.search || '');
    }
  }

  function applySubmittedState() {
    var thanks = document.querySelector('[data-quote-thanks]');
    if (!thanks) return;

    var serverSuccess = thanks.getAttribute('data-server-success') === 'true';
    var success = serverSuccess || hasSubmittedFlag();
    var formBody = document.querySelector('[data-quote-form-body]');

    thanks.hidden = !success;
    if (formBody) formBody.hidden = success;

    if (!success) return;

    if (!serverSuccess) {
      try {
        thanks.focus();
      } catch (e) {
        /* focus desteklenmiyorsa onemsiz */
      }
    }

    /* Store.write([]) quote:updated yayinlar; sayac 0'a,
     * sticky bar gizli duruma, drawer bos duruma geser. */
    if (Store.count() > 0) Store.write([]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySubmittedState);
  } else {
    applySubmittedState();
  }

  /* ---------------------------------------------------------------
   * <quote-summary> — teklif formundaki gorunur ozet + gizli alanlar
   * ------------------------------------------------------------- */
  if (!window.customElements.get('quote-summary')) {
    window.customElements.define(
      'quote-summary',
      class QuoteSummary extends HTMLElement {
        connectedCallback() {
          this.listEl = this.querySelector('[data-quote-summary-list]');
          this.emptyEl = this.querySelector('[data-quote-summary-empty]');
          this.countEl = this.querySelector('[data-quote-summary-count]');
          this.readableInput = this.querySelector('[data-quote-field-readable]');
          this.handleInput = this.querySelector('[data-quote-field-handles]');

          this.sync = this.sync.bind(this);
          this.onListClick = this.onListClick.bind(this);
          if (this.listEl) this.listEl.addEventListener('click', this.onListClick);

          this.hydrateFromUrl();
          onUpdate(this.sync);
          this.sync();
        }

        disconnectedCallback() {
          document.removeEventListener(UPDATE_EVENT, this.sync);
        }

        hydrateFromUrl() {
          var params;
          try {
            params = new URLSearchParams(window.location.search);
          } catch (e) {
            return;
          }
          var raw = params.get('konseptler');
          if (!raw) return;
          var handles = raw
            .split(',')
            .map(function (value) {
              return decodeURIComponent(value.trim());
            })
            .filter(Boolean);
          Store.hydrateFromHandles(handles, null);
        }

        onListClick(event) {
          var button = event.target.closest('[data-quote-remove]');
          if (!button) return;
          event.preventDefault();
          Store.remove(button.getAttribute('data-quote-remove'));
        }

        sync() {
          var list = Store.read();
          var count = list.length;

          if (this.countEl) this.countEl.textContent = String(count);
          if (this.emptyEl) this.emptyEl.hidden = count > 0;

          if (this.listEl) {
            this.listEl.textContent = '';
            this.listEl.hidden = count === 0;
            for (var i = 0; i < list.length; i++) {
              var item = list[i];
              var li = document.createElement('li');
              li.className = 'quote-summary__item';

              if (item.image) {
                var img = document.createElement('img');
                img.className = 'quote-summary__image';
                img.src = item.image;
                img.alt = '';
                img.loading = 'lazy';
                img.decoding = 'async';
                img.width = 72;
                img.height = 72;
                li.appendChild(img);
              }

              var title = document.createElement(item.url ? 'a' : 'span');
              title.className = 'quote-summary__title';
              title.textContent = item.title;
              if (item.url) title.setAttribute('href', item.url);
              li.appendChild(title);

              var remove = document.createElement('button');
              remove.type = 'button';
              remove.className = 'quote-summary__remove';
              remove.setAttribute('data-quote-remove', item.handle);
              remove.setAttribute(
                'aria-label',
                (this.dataset.labelRemove || 'Cikar') + ': ' + item.title
              );
              remove.textContent = this.dataset.labelRemove || 'Çıkar';
              li.appendChild(remove);

              this.listEl.appendChild(li);
            }
          }

          /* E-postaya dusen okunabilir liste:
           *   1. Konsept Adi
           *   https://alan-adi/lookbook/handle
           * Aralarinda bos satir birakilir. type="hidden" alanlarda
           * satir sonlari korunur (deger temizleme algoritmasi yok). */
          if (this.readableInput) {
            this.readableInput.value = list
              .map(function (item, index) {
                var line = index + 1 + '. ' + item.title;
                var url = absoluteConceptUrl(item);
                return url ? line + '\n' + url : line;
              })
              .join('\n\n');
          }
          if (this.handleInput) {
            this.handleInput.value = list
              .map(function (item) {
                return item.handle;
              })
              .join(',');
          }
        }
      }
    );
  }
})();
